import { z } from 'zod';
import { zStringRequired } from '../../z';
export const physicianOrderValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        provider: z.string().min(1, 'Provider is required'),
        orderDate: z.string().min(10, 'Order date is required'),
        subject: z.string().nullish(),
        description: z.string().min(1, 'Order description is required'),
        priorCorrespondence: z.string().nullish(),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
